/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSeparatorVertical = createReactComponent("outline", "separator-vertical", "IconSeparatorVertical", [["path", { "d": "M12 4l0 16", "key": "svg-0" }], ["path", { "d": "M8 8l-4 4l4 4", "key": "svg-1" }], ["path", { "d": "M16 16l4 -4l-4 -4", "key": "svg-2" }]]);

export { IconSeparatorVertical as default };
//# sourceMappingURL=IconSeparatorVertical.mjs.map
